module.exports = __webpack_public_path__ + "img/photo-04.c0faccdd.jpg";